import { getLocaleFromPathname } from "../lib/localeRoutes";

interface LanguageInstance {
  language: string;
  changeLanguage(language: string): Promise<unknown>;
}

export async function prepareRenderLocale(
  instance: LanguageInstance,
  routePath?: string,
  browserPathname?: string,
): Promise<void> {
  const locale = getLocaleFromPathname(routePath ?? browserPathname ?? "/");
  if (instance.language !== locale) {
    await instance.changeLanguage(locale);
  }
}
